/**
 * Save-time validation of a TPO signup config's exposed pipelines (DEV-4697). SkynetAPI BFF —
 * `POST /api/admin-panel/tpo-signup-configurations/exposed-pipelines/validate`.
 *
 * Request:  { exposedPipelines: [{ pipelineId, scope: { type, channelIds }, defaultTemplateNames }] }
 * Response: { isValid, pipelines: [{ pipelineId, pipelineName, isValid, errors: string[] }] }
 *
 * The server re-checks each entry's channel scope AND that the pipeline's filter structurally
 * fences rows to the viewer's sub-company. IMPORTANT: a failed validation is returned as a
 * 400 whose BODY is the same validation report — the caller must read the report off the error
 * response, and treat a network/5xx failure as "could not verify" (fail closed, never open).
 */
export class TpoExposedPipelinesValidationApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async validateExposedPipelines({ exposedPipelines }) {
    return this.#http.post(
      '/api/admin-panel/tpo-signup-configurations/exposed-pipelines/validate',
      {
        exposedPipelines,
      },
    );
  }
}
